import React from "react";
import WebSVG from '../components/WebSVG';

function SvgCard(props) {
    var svgSource = props.code;
    var variables = props.vars;
    var width = props.width;
    var key = variables.card_type;
    var keys = Object.keys(variables);
    var outputVariables = props.outputVariables;
    var elements_dy = props.elements_dy;
    var enableFocus = props.vars == null || props.vars.enableFocus == null || props.vars.enableFocus;
    var scrollEvents = props.scrollEvents;

    for (var i = 0; i < keys.length; i++) {
        const val = unescape(variables[keys[i]])
            .replace(new RegExp("&apos;", 'g'), "'")
            .replace(new RegExp("&dollar;", 'g'), "$")
            .replace(new RegExp("&quot;", 'g'), "\"")
            .replace(new RegExp("&#92;", 'g'), "\\"); //todo: change this and optimize

        svgSource = svgSource.replace(new RegExp("{" + keys[i] + "}", 'g'), val);
    }

    return (
        <WebSVG id={key} width={width} src={svgSource} onAction={props.onAction} variables={variables} outputVariables={outputVariables} elements_dy={elements_dy} enableFocus={enableFocus} scrollEvents={scrollEvents} />
    );
}

export default SvgCard;
